import '../node_modules/leaflet/dist/leaflet.css'
import React from 'react'
import { Map, TileLayer, Marker, Tooltip } from 'react-leaflet'
import L from 'leaflet';

//workaround Market images bug
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


export default class Localisation extends React.Component {
  constructor() {
    super()
    this.state = {
      lat: 48.660744,
      lng: -1.990023,
      zoom: 13
    }
  }
  
  render() {
    const position = [this.state.lat, this.state.lng]
    return (
      <Map center={position} zoom={this.state.zoom}>
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Tooltip>HomeMalo<br />4 Avenue Louis Aubert</Tooltip>
        </Marker>
      </Map>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Localisation.js